export default "__VITE_ASSET__DPnZ$$lT__"